import { render } from "./LoadingAnimation.vue?vue&type=template&id=375a8a43"
const script = {}

import "./LoadingAnimation.vue?vue&type=style&index=0&id=375a8a43&lang=css"

import exportComponent from "/home/runner/work/PEP/PEP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__